'use client'

import React from 'react'
import {observer, useLocalObservable} from 'mobx-react'
import {PageType} from '@/src/core/domain/entities/page'
import {makeObservable, observable} from 'mobx'
import {LoadPageDataParams} from '@/src/core/domain/page'

interface PageContentProps extends React.PropsWithChildren {
  params: LoadPageDataParams
}

class PagePropsStore {
  @observable
  transformKey: LoadPageDataParams['transformKey']

  @observable
  pageType: ValuesOf<typeof PageType>

  @observable
  options: LoadPageDataParams['container']

  constructor(params: LoadPageDataParams) {
    this.pageType = params.type
    this.options = params.container
    this.transformKey = params.transformKey

    makeObservable(this)
  }
}

const PagePropsContext = React.createContext<Nullable<PagePropsStore>>(null)

export const PageContentProvider = observer(({children, params}: PageContentProps) => {
  const pagePropsStore = useLocalObservable(() => new PagePropsStore(params))

  return <PagePropsContext.Provider value={pagePropsStore}>{children}</PagePropsContext.Provider>
})

export const usePageProps = () => {
  const pagePropsStore = React.useContext(PagePropsContext)

  if (!pagePropsStore) throw new Error('usePageProps must be used within PageContentProvider()')

  return pagePropsStore
}
